import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import DoNotDisturbStyles from './DoNotDisturbState.module.scss'
import dayjs from 'dayjs'
import { pluralize } from 'utils'
import { Button } from 'blaze-ui/Button'
import { Heading } from 'blaze-ui/Heading/Heading'

interface Props {
  onClose: () => void
}

export const DoNotDisturbState = observer(({ onClose }: Props) => {
  const { notifications } = useRootStore()

  const mutedAt = dayjs(notifications.mutedAt)
  const diffInHours = dayjs().diff(mutedAt, 'hour')
  const diffInDays = dayjs().diff(mutedAt, 'day')

  let time: string
  if (diffInDays > 1) {
    time = `${diffInDays} days`
  } else {
    time = diffInHours < 1 ? 'less than one hour' : `${diffInHours} ${pluralize('hour', diffInHours)}`
  }

  const unmuteNotifications = () => {
    notifications.unmute()
    onClose()
  }

  return (
    <div className={DoNotDisturbStyles.doNotDisturbContainer}>
      <Heading level={4}>🧘 Congrats!</Heading>
      <div className={DoNotDisturbStyles.doNotDisturbText}>You've spent {time} without distractions</div>
      <Button fullWidth size="lg" variant="secondary" onPress={unmuteNotifications}>
        Turn On Notifications
      </Button>
    </div>
  )
})
